import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.885 8.494a8.67 8.67 0 0 1 12.026-.002q.07.043.13.104a.8.8 0 0 1 .103.129 8.67 8.67 0 0 1-.113 12.141.75.75 0 0 1-1.061 0l-.039-.042-.041-.038-1.198-1.197a.75.75 0 1 1 1.061-1.061l.719.719a7.13 7.13 0 0 0 1.557-3.761h-1.062a.75.75 0 1 1 0-1.5h1.063a7.13 7.13 0 0 0-1.557-3.762l-.629.63a.75.75 0 0 1-1.061-1.061l.629-.63a7.14 7.14 0 0 0-3.795-1.562v.834a.75.75 0 1 1-1.5 0v-.826a7.13 7.13 0 0 0-3.729 1.554l3.422 3.422.052.057a2.3 2.3 0 0 1 1.055-.256 2.3 2.3 0 0 1 2.3 2.3 2.3 2.3 0 0 1-2.3 2.3 2.3 2.3 0 0 1-2.3-2.3 2.3 2.3 0 0 1 .216-.969 1 1 0 0 1-.083-.071L7.965 10.86l-.638-.637a7.14 7.14 0 0 0-1.556 3.762h.996a.75.75 0 1 1 0 1.5h-.996a7.13 7.13 0 0 0 1.557 3.762l.721-.72a.75.75 0 0 1 1.061 1.061l-1.197 1.197a1 1 0 0 1-.06.053q-.01.013-.021.027a.75.75 0 0 1-1.004.052l-.057-.052-.309-.322A8.67 8.67 0 0 1 6.659 8.72a.7.7 0 0 1 .226-.226m6.032 5.392a.8.8 0 0 0-.8.8.8.8 0 0 0 .8.8.8.8 0 0 0 .8-.8.8.8 0 0 0-.8-.8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.801 4.065a.75.75 0 0 1 .75.75v2.9a.75.75 0 0 1-.75.75H2.9a.75.75 0 1 1 0-1.5h1.052l-1.461-1.35a.75.75 0 0 1 1.018-1.102l1.542 1.423V4.815a.75.75 0 0 1 .75-.75"
}));
const ForwardRef = forwardRef(SvgComponent);
export const GaugeArrowLeftIcon = ForwardRef;